<template>
  <div class="card">
    <div class="card-header">Market Indices</div>
     <pulse-loader
      v-if="loadingTable"
      class="mt-5 text-center"
    ></pulse-loader>
    <table class="table table-hover" v-else>
      <thead>
        <tr class="">
          <th scope="col" class="tableHead">Name</th>
          <th scope="col" class="tableHead">First Day</th>
          <th scope="col" class="tableHead">Last Day</th>
          <th scope="col" class="tableHead">Change</th>
          <th scope="col" class="tableHead">% Change</th>
        </tr>
      </thead>
      <tbody v-if="dsexList && dsesList && ds30List && cdsetList">
        <tr >
          <td>DSEX</td>
          <td>{{ dsexList["First Day Value"].toFixed(2) }}</td>
          <td>{{ dsexList["Last Day Value"].toFixed(2) }}</td>
          <td>{{ dsexList["Change"].toFixed(2) }}</td>
          <td>{{ dsexList["Change(%)"].toFixed(2) }}</td>
        </tr>
        <tr>
          <td>DSES</td>
          <td>{{ dsesList["First Day Value"].toFixed(2) }}</td>
          <td>{{ dsesList["Last Day Value"].toFixed(2) }}</td>
          <td>{{ dsesList["Change"].toFixed(2) }}</td>
          <td>{{ dsesList["Change(%)"].toFixed(2) }}</td>
        </tr>
        <tr>
          <td>DS30</td>
          <td>{{ ds30List["First Day Value"].toFixed(2) }}</td>
          <td>{{ ds30List["Last Day Value"].toFixed(2) }}</td>
          <td>{{ ds30List["Change"].toFixed(2) }}</td>
          <td>{{ ds30List["Change(%)"].toFixed(2) }}</td>
        </tr>
        <tr>
          <td>CDSET</td>
          <td>{{ cdsetList["First Day Value"].toFixed(2) }}</td>
          <td>{{ cdsetList["Last Day Value"].toFixed(2) }}</td>
          <td>{{ cdsetList["Change"].toFixed(2) }}</td>
          <td>{{ cdsetList["Change(%)"].toFixed(2) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from "vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  data: function () {
    return {
      dsexList: null,
      dsesList: null,
      ds30List: null,
      cdsetList: null,
      base_url:
        process.env.NODE_ENV === "production"
          ? "https://apidfl.bicm.ac.bd"
          : "http://localhost:8000",
          loadingTable : 1
    };
  },
  components : {
    PulseLoader
  },
  methods: {
    loadDsexData() {
      Vue.axios
        .get(this.base_url + "/api/monthly-indices-dsex?timestamp=" + new Date().getTime())
        .then((response) => {
          this.dsexList = response.data;
          this.loadingTable = 0
        });
    },
    loadDsesData() {
      Vue.axios
        .get(this.base_url + "/api/monthly-indices-dses?timestamp=" + new Date().getTime())
        .then((response) => {
          this.dsesList = response.data;
        });
    },
    loadDs30Data() {
      Vue.axios
        .get(this.base_url + "/api/monthly-indices-ds30?timestamp=" + new Date().getTime())
        .then((response) => {
          this.ds30List = response.data;
        });
    },
    loadCdsetData() {
      Vue.axios
        .get(this.base_url + "/api/monthly-indices-cdset?timestamp=" + new Date().getTime())
        .then((response) => {
          this.cdsetList = response.data;
        });
    },
  },
  mounted() {
    this.loadDsexData();
    this.loadDsesData();
    this.loadDs30Data();
    this.loadCdsetData();
  },
};
</script>

<style>
.tableHead {
  font-size: 11px;
}
</style>
